import { useEffect } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { Provider as StoreProvider } from 'react-redux';
import { ThemeProvider } from '@nazka/nazka.mapframe.components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import TranslationsProvider, { LocalizedRoutes } from '@utils/i18n/i18n';
import WindowObserver from '@utils/WindowObserver/WindowObserver';
import ErrorBoundary from '@utils/ErrorBoundary/ErrorBoundary';
import Cookies from '@utils/Cookies/Cookies';

import routes from '@App/app.routes';
import store from '@App/app.store';
import translator from '@App/app.translator';

import theme from '@css/theme.style.json';
import MetaTags from './components/MetaTags/MetaTags';

import './app.styl';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

function App() {
  useEffect(() => {
    document.documentElement.setAttribute('data-app-initialised', true);
    document.addEventListener('fullscreenchange', () => {
      const mapframeEl = document.querySelector('#js-mapframe');
      if (document.fullscreenElement) mapframeEl.classList.add('fullscreen');
      else mapframeEl.classList.remove('fullscreen');
    });
  }, []);

  return (
    <StoreProvider store={store}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <ErrorBoundary>
              <TranslationsProvider translator={translator}>
                <LocalizedRoutes>
                  {routes.map(({ path, element }) => (
                    <Route path={path} element={element} key={path} />
                  ))}
                </LocalizedRoutes>
                <Cookies useConfig className="cookies" />
                <MetaTags />
              </TranslationsProvider>
            </ErrorBoundary>
          </BrowserRouter>
        </ThemeProvider>
        <WindowObserver />
      </QueryClientProvider>
    </StoreProvider>
  );
}

export { queryClient };

export default App;
